/* global require, window */
'use strict';
if (typeof window === 'undefined' || window['PRIVATE_CAMERAS_APP_IS_AUTH_PAGE']) {
    // no need in polyfills - either we are under node js or polyfills was already loaded, but we need stubs
    require('./legacy-dependencies');
} else {
    require('../lib/ie10-viewport-bug-workaround');
    require('../lib/ie9-10-babel-6-polyfix');
    require('./common-dependences');
}

var $ = require('jquery');
window.jQuery = window.$ = $;
require('../lib/jquery.xdr-fix');
